import { DatePicker, Progress, Table } from 'antd';
import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { GetAvancos, getAvancosFisicos, getFisico, getRealizadoMes } from '@actions/bancoActions';
import { SetPageHeader } from '@actions/userActions';
import { doubleMask1, moneyMask } from '@utils/masks';
import moment from 'moment';
import { naturalSorter } from '@utils/filterandsort';
import '../../../assets/scss/Fisico.scss';
import GruposModal from './GruposModal';
import { useAppDispatch, useAppSelector } from '@config/reduxStore';
import { FisicoBanco } from '@models/Fisico';

function FisicoReport() {
  const dispatch = useAppDispatch();
  const { id } = useParams();
  const [meses, setMeses] = useState(new Array(1).fill(0));
  const [inicial, setInicial] = useState(moment(new Date()));
  const [lancamentos, setLancamentos] = useState([]);
  const [mes, setMes] = useState(moment(new Date()));
  const [grupos, setGrupos] = useState({ visible: false, categoria: '' });
  const {
    fisico,
    loadingFisico,
    avancos,
    loadingAvancos,
    realizados,
    loadingRealizados,
    orcamento,
    avancosFisicos,
    loadingAvancosFisicos,
  } = useAppSelector((state) => state.banco);
  useEffect(() => {
    dispatch(getFisico(id));
    dispatch(GetAvancos(id));
    dispatch(getRealizadoMes(id));
    dispatch(getAvancosFisicos(id));
  }, [id]);
  useEffect(() => {
    dispatch(
      SetPageHeader({
        title: 'Evolução das Medições',
        backbutton: true,
        extras: [],
        subtitle: orcamento?.descricao,
        menu: 'fisico',
      })
    );
  }, [orcamento]);
  useEffect(() => {
    if (avancos && realizados) {
      const mindate = moment(avancos.dataInicio).set('date', 1);

      const maxdate = moment.max(realizados.map((c) => c.mes));
      const months = moment(maxdate).diff(mindate, 'month');
      setInicial(avancos.meses > months ? moment(avancos.dataInicio) : moment(mindate));
      setMeses(new Array(Math.max(months, avancos.meses)).fill(0));
      setLancamentos(avancos.fisicoFinanceiro.map((c) => ({ ...c, mes: moment(c.mes) })));
    }
  }, [avancos, realizados]);
  const strokeColor = {
    from: '#108ee9',
    to: '#87d068',
  };

  return (
    <div>
      <GruposModal visible={grupos.visible} setVisible={setGrupos} categoria={grupos.categoria} />
      <DatePicker.MonthPicker format="MM/YYYY" value={mes} onChange={(v) => setMes(v)} />
      <Table
        size="small"
        className="fisicoform"
        dataSource={[...fisico].sort((a, b) => naturalSorter(a.descricao, b.descricao))}
        bordered
        pagination={false}
        scroll={{ x: 500 + meses.length * 150, y: 'calc(100vh - 280px)' }}
        rowKey="id"
        loading={loadingFisico || loadingAvancos || loadingRealizados || loadingAvancosFisicos}
        summary={(data) => (
          <Table.Summary fixed>
            <Table.Summary.Row>
              <Table.Summary.Cell index={0} align="right">
                <strong>TOTAL</strong>
              </Table.Summary.Cell>
              <Table.Summary.Cell index={1} align="right">
                <div style={{ fontWeight: 'bold' }}>
                  <div>{moneyMask.format(data.reduce((a, b) => a + b.orcado, 0))}</div>
                  <div>100%</div>
                </div>
              </Table.Summary.Cell>
              <Table.Summary.Cell index={2} align="right">
                <strong>
                  <div>
                    <div>MEDIÇÃO PLANEJADA</div>
                    <div>MEDIDO</div>
                    <div>VALOR ESPERADO</div>
                    <div>VALOR MEDIDO</div>
                  </div>
                </strong>
              </Table.Summary.Cell>
              <Table.Summary.Cell index={3} align="right">
                <strong>
                  <div>
                    <div>
                      <Progress
                        strokeColor={strokeColor}
                        percent={
                          Math.ceil(
                            (lancamentos
                              .filter((c) => moment(c.mes) < mes)
                              .reduce(
                                (a, b) => a + b.planejado * fisico.find((c) => c.id === b.categoriaID)?.orcado,
                                0
                              ) /
                              fisico.reduce((a, b) => a + b.orcado, 0)) *
                              1
                          ) / 1
                        }
                      />
                    </div>
                    <div>
                      <Progress
                        strokeColor={strokeColor}
                        percent={
                          Math.ceil(
                            (avancosFisicos.reduce(
                              (a, b) => a + b.realizado * fisico.find((c) => c.id === b.categoriaID)?.orcado,
                              0
                            ) /
                              fisico.reduce((a, b) => a + b.orcado, 0)) *
                              1
                          ) / 1
                        }
                      />
                    </div>
                    <div>
                      {moneyMask.format(
                        lancamentos
                          .filter((c) => moment(c.mes) <= mes)
                          .reduce(
                            (a, b) => a + (b.planejado * fisico.find((c) => c.id === b.categoriaID)?.orcado) / 100,
                            0
                          )
                      )}
                    </div>
                    <div>{moneyMask.format(realizados.reduce((a, b) => a + b.valor, 0))}</div>
                  </div>
                </strong>
              </Table.Summary.Cell>
              {meses.map((_, index) => {
                const current = moment(inicial).add(index, 'month').format('MM/YYYY');
                return (
                  <Table.Summary.Cell index={4 + index} key={index} align="right">
                    <strong>
                      <div>
                        <div>
                          <Progress
                            strokeColor={strokeColor}
                            percent={
                              Math.ceil(
                                (lancamentos
                                  .filter((c) => moment(c.mes).format('MM/YYYY') === current)
                                  .reduce(
                                    (a, b) => a + b.planejado * fisico.find((c) => c.id === b.categoriaID)?.orcado,
                                    0
                                  ) /
                                  fisico.reduce((a, b) => a + b.orcado, 0)) *
                                  1
                              ) / 1
                            }
                          />
                        </div>
                        <div>
                          <Progress
                            strokeColor={strokeColor}
                            percent={
                              Math.ceil(
                                (avancosFisicos.reduce(
                                  (a, b) =>
                                    a +
                                    b.realizado *
                                      fisico.find(
                                        (c) => c.id === b.categoriaID && moment(c.mes).format('MM/YYYY') === current
                                      )?.orcado,
                                  0
                                ) /
                                  fisico.reduce((a, b) => a + b.orcado, 0)) *
                                  1
                              ) / 1
                            }
                          />
                        </div>
                        <div>
                          {moneyMask.format(
                            lancamentos
                              .filter((c) => moment(c.mes).format('MM/YYYY') === current)
                              .reduce(
                                (a, b) => a + (b.planejado * fisico.find((c) => c.id === b.categoriaID)?.orcado) / 100,
                                0
                              )
                          )}
                        </div>
                        <div>
                          {moneyMask.format(
                            realizados
                              .filter((c) => moment(c.mes).format('MM/YYYY') === current)
                              .reduce((a, b) => a + b.valor, 0)
                          )}
                        </div>
                      </div>
                    </strong>
                  </Table.Summary.Cell>
                );
              })}
            </Table.Summary.Row>
          </Table.Summary>
        )}
      >
        <Table.Column title="Etapa" dataIndex="descricao" width={200} fixed="left" render={(v) => v.toUpperCase()} />
        <Table.Column
          title="Orçado"
          dataIndex="orcado"
          fixed="left"
          width={130}
          render={(v) => (
            <div>
              <div>{moneyMask.format(v)}</div>
              <div>{doubleMask1.format((100 * v) / fisico.reduce((a, b) => a + b.orcado, 0))}</div>
            </div>
          )}
          align="right"
        />
        <Table.Column
          align="right"
          fixed="left"
          width={150}
          render={() => (
            <div>
              <div>MEDIÇÃO PLANEJADA</div>
              <div>MEDIDO</div>
              <div>VALOR ESPERADO</div>
              <div>VALOR MEDIDO</div>
            </div>
          )}
        />
        <Table.Column
          title={'Situação ' + mes.format('MM/YYYY')}
          dataIndex="realizado"
          align="right"
          fixed="left"
          width={150}
          render={(v, row: FisicoBanco) => (
            <div>
              <div>
                <Progress
                  strokeColor={strokeColor}
                  percent={lancamentos
                    .filter((c) => moment(c.mes) < mes)
                    .filter((c) => c.categoriaID === row.id)
                    .reduce((a, b) => a + b.planejado, 0)}
                />
              </div>
              <div>
                <Progress
                  strokeColor={strokeColor}
                  percent={avancosFisicos.filter((c) => c.categoriaID === row.id).reduce((a, b) => a + b.realizado, 0)}
                />
              </div>
              <div>
                {moneyMask.format(
                  (row.orcado *
                    lancamentos
                      .filter((c) => moment(c.mes) < mes)
                      .filter((c) => c.categoriaID === row.id)
                      .reduce((a, b) => a + b.planejado, 0)) /
                    100
                )}
              </div>
              <div
                style={{
                  color:
                    (row.orcado *
                      lancamentos
                        .filter((c) => moment(c.mes) < mes)
                        .filter((c) => c.categoriaID === row.id)
                        .reduce((a, b) => a + b.planejado, 0)) /
                      100 >
                    v
                      ? 'red'
                      : 'blue',
                }}
              >
                {moneyMask.format(v)}
              </div>
            </div>
          )}
        />
        {meses.map((_, index) => {
          const current = moment(inicial).add(index, 'month').format('MM/YYYY');
          return (
            <Table.Column
              key={index}
              className={current === mes.format('MM/YYYY') && 'today'}
              title={current}
              align="right"
              width={150}
              render={(_, row: FisicoBanco) => (
                <div>
                  <div>
                    <Progress
                      strokeColor={strokeColor}
                      percent={
                        lancamentos?.find(
                          (c) => c.categoriaID === row.id && moment(c.mes).format('MM/YYYY') === current
                        )?.planejado || 0
                      }
                    />
                  </div>
                  <div>
                    <Progress
                      strokeColor={strokeColor}
                      percent={
                        avancosFisicos.find(
                          (c) => c.categoriaID === row.id && moment(c.mes).format('MM/YYYY') === current
                        )?.realizado
                      }
                    />
                  </div>
                  <div>
                    {moneyMask.format(
                      (lancamentos?.find((c) => c.categoriaID === row.id && moment(c.mes).format('MM/YYYY') === current)
                        ?.planejado *
                        row.orcado) /
                        100 || 0
                    )}
                  </div>
                  <div>
                    {moneyMask.format(
                      realizados
                        ?.filter((c) => c.categoriaID === row.id && moment(c.mes).format('MM/YYYY') === current)
                        ?.reduce((a, b) => a + b.valor, 0) || 0
                    )}
                  </div>
                </div>
              )}
            />
          );
        })}
      </Table>
    </div>
  );
}

export default FisicoReport;
